import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

import styles from 'features/gateway/views/gateway-details/gateway-information.module.scss';

interface ReadOnlyIpAddressFieldProps {
  ipAddress: string;
  cidr?: number;
}

const ReadOnlyIpAddressField = ({ ipAddress, cidr }: ReadOnlyIpAddressFieldProps) => {
  const { t } = useTranslation('gateway');
  const displayValue = [ipAddress, cidr ?? 24].filter(Boolean).join('/');

  return (
    <div className={styles.informationItem}>
      <Typography variant="h5">{t('details.information.ipAddressLabel')}</Typography>
      <Typography variant="subtitle1" className={`${styles.textFormat}`}>
        {displayValue || '-'}
      </Typography>
    </div>
  );
};

export default ReadOnlyIpAddressField;
